import { render, staticRenderFns } from "./PlusCircle.vue?vue&type=template&id=36a84336"
import script from "./PlusCircle.vue?vue&type=script&lang=js"
export * from "./PlusCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports